import './App.css';

import ThemeProviderMUI from '@mui/material/styles/ThemeProvider';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import theme, { cacheRtl } from 'styles/theme'
import Router1 from 'components/NotUse';
import Router from './router/AuthRoutes';
import { actions } from 'store';

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AbilityContext } from 'components/Permissions/Can';
import { history } from 'router/navigationService';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { CacheProvider } from '@emotion/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from 'keys/queryClient';
import { alerts as alertKeys } from 'keys'

import 'react-toastify/dist/ReactToastify.css';
import Helmet from './Helmet'
import ability from 'config/ability'
import VersionMessagePopup from 'components/VersionMessagePopup';

function App() {
  const dispatch = useDispatch()
  const { alerts } = useSelector(state => state.general)
  const { roleIndex } = useSelector(state => state.user)

  useEffect(() => {
    dispatch(actions.initialFirebase())
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <AbilityContext.Provider value={ability(roleIndex)}>
        <CacheProvider value={cacheRtl}>
          <ThemeProviderMUI theme={theme}>
            <div className="App">
              <Helmet />
              <ReactQueryDevtools initialIsOpen={false} />
              <HistoryRouter history={history}>
                <Router />
              </HistoryRouter>
              {
                alerts[alertKeys.versionMessage].open &&
                <VersionMessagePopup />
              }
            </div>
          </ThemeProviderMUI>
        </CacheProvider>
        <ToastContainer />
      </AbilityContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
